<app-global-alert></app-global-alert>
<router-outlet></router-outlet>

<ngx-spinner
  [name]="spinnerName"
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="square-jelly-box"
  [fullScreen]="true">
  <p style="color: white"> Cargando... </p>
</ngx-spinner>
